const baseInfo = {
  BASE_TITLE: '苏州市名仕医院',
  SERVICE_INTERCEPT: true,
  REQUEST_TIMEOUT: 35000,
  BASE_IMG_URL: 'https://www.szmshospital.com/wxgzh/',
  // BASE_URL: 'http://192.168.3.46:9095/',
  BASE_URL: 'https://www.szmshospital.com/payment',
  BASE_PDF_URL: 'https://www.szmshospital.com/pdf'
}
export default baseInfo
